
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/h/[hotel]",
      function () {
        return require("private-next-pages/h/[hotel]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/h/[hotel]"])
      });
    }
  